import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Cool thing Thursday: Fog of World",
  "description": "",
  "published": "2012-10-04T00:00:00.000Z",
  "redirect_from": ["/blog/cool-thing-thursday-fog-of-world/swizec/5363"],
  "categories": "Apps, Belgrade, Dubrovnik, IPhone, London, RunKeeper, Uncategorized, Zurich",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2012/10/area-explored.png"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2012/10/area-explored.png",
          "alt": "Area of world explored",
          "title": "Area of world explored"
        }}></img></a></p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2012/10/percentage-explored.png"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2012/10/percentage-explored.png",
          "alt": "Percentage of world explored",
          "title": "Percentage of world explored"
        }}></img></a></p>
    <p><a parentName="p" {...{
        "href": "http://fogofworld.com"
      }}>{`Fog of World`}</a>{` is a toy.`}</p>
    <p>{`A wonderful magnificent toy I wouldn't let you pry from my cold dead fingers! And I wish it came out six months ago, not last week.`}</p>
    <p>{`What is it?`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/10/ljubljana-fog.png",
        "alt": "Fog over my world",
        "title": "Fog over my world"
      }}></img></p>
    <p>{`Oh it's just an `}<em parentName="p">{`awesome`}</em>{` visualisation of where you've been in your life and how much of the world you've explored so far. That runs on your `}<a parentName="p" {...{
        "href": "http://www.apple.com/iphone",
        "title": "iPhone"
      }}>{`iPhone`}</a>{`. And sucks the ever living hell out of your battery with the GPS chip.`}</p>
    <p>{`To be honest, I'm not even certain why I like it. Probably the same reason I like `}<a parentName="p" {...{
        "href": "http://www.foursquare.com/",
        "title": "Foursquare"
      }}>{`Foursquare`}</a>{` ... it's just incredibly cool to have a historical log of where you've been and what you've been up to. Call me sentimental, but that's really cool. Even though I find looking at old photographs boring, a log of locations? Sold.`}</p>
    <p>{`Maybe I'm just a traveler at heart.`}</p>
    <p>{`The more important aspect of Fog of World is that it affects your life ever so imperceptibly. Walking around town yesterday - less than a kilometer from home - I discovered a new street. Just because I wanted to expand my fog of world a bit, get that tiny small percentage more. Explore just a bit.`}</p>
    <p>{`It was marvelous. I love it when software gently nudges me to expand my horizons.`}</p>
    <p>{`That said, this has been a marvelous year for traveling. I've been to `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=51.5072222222,-0.1275&spn=0.1,0.1&q=51.5072222222,-0.1275%20(London)&t=h",
        "title": "London"
      }}>{`London`}</a>{`, `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=45.25,19.85&spn=0.1,0.1&q=45.25,19.85%20(Novi%20Sad)&t=h",
        "title": "Novi Sad"
      }}>{`Novi Sad`}</a>{`, `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=44.8205555556,20.4622222222&spn=0.1,0.1&q=44.8205555556,20.4622222222%20(Belgrade)&t=h",
        "title": "Belgrade"
      }}>{`Belgrade`}</a>{`, `}<a parentName="p" {...{
        "href": "http://whc.unesco.org/en/list/95",
        "title": "Old City of Dubrovnik"
      }}>{`Dubrovnik`}</a>{`, `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=47.3666666667,8.55&spn=0.1,0.1&q=47.3666666667,8.55%20(Zurich)&t=h",
        "title": "Zurich"
      }}>{`Zurich`}</a>{` and I'm going to Paris in a week. If only this app existed 6 months earlier, there would be much less fog over my world.`}</p>
    <p>{`But hey, just discovered I can import all my `}<a parentName="p" {...{
        "href": "http://www.runkeeper.com/",
        "title": "RunKeeper"
      }}>{`RunKeeper`}</a>{` data going back to early 2011. Sweet!`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/10/downtown-ljubljana-fog.png",
        "alt": "Downtown perambulations are quite sporadic",
        "title": "Downtown perambulations are quite sporadic"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/10/photo-3.png",
        "alt": "The app eggs you on to travel more",
        "title": "The app eggs you on to travel more"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.gizmodo.co.uk/2012/10/this-fog-of-world-app-might-be-the-funnest-app-ive-seen-in-a-long-time/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/116068823_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.gizmodo.co.uk/2012/10/this-fog-of-world-app-might-be-the-funnest-app-ive-seen-in-a-long-time/"
        }}>{`This Fog of World App Might Be the Funnest App I've Seen in a Long Time`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.ocregister.com/news/inland-373439-weather-highs.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/116196619_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.ocregister.com/news/inland-373439-weather-highs.html"
        }}>{`Slow cooling; fall weather next week?`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/a-roadtrip-fin/swizec/4972"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/104877705_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://swizec.com/blog/a-roadtrip-fin/swizec/4972"
        }}>{`A roadtrip: fin`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=2cb8658c-ea3c-4051-b034-52ef0d0481f1",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      